import { toRefs, ref, computed, watch } from 'vue';
import ProfileBtn from '../btn/component-lib.esm3.js';
import ProfileLinkWrapper from '../component-lib.esm4.js';
import { useLink } from '../component-lib.esm6.js';
import BtnExpand from '../shared/component-lib.esm.js';
import LoadingBlock from '../../components/loading-block/component-lib.esm.js';
import { LINK_PROPS } from '../component-lib.esm2.js';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';

//
var script = {
  components: {
    ProfileBtn,
    ProfileLinkWrapper,
    BtnExpand,
    ChevronIcon,
    Form: () => ({
      component: import('./component-lib.esm3.js').then(d => d.default),
      loading: LoadingBlock
    }),
    Success: () => ({
      component: import('./component-lib.esm4.js').then(d => d.default),
      loading: LoadingBlock
    })
  },
  props: {
    ...LINK_PROPS,
    isSending: Boolean,
    success: Boolean,
    hasError: Boolean,
    errorMessage: String
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      link
    } = toRefs(props);
    const expandRef = ref(null);
    const isOpen = ref(false);
    const hasBeenOpened = ref(false);
    const {
      id,
      btnProps
    } = useLink(props, {
      emit
    });
    const emailOptions = computed(() => {
      return link.value.email_options;
    });

    // Override highlight after link click
    const highlight = computed(() => {
      return hasBeenOpened.value ? '' : link.value.highlight;
    });
    async function handleClick() {
      isOpen.value = !isOpen.value;
      if (isOpen.value) emit('click');
    }
    watch(isOpen, () => {
      hasBeenOpened.value = true;
    });
    return {
      id,
      handleClick,
      highlight,
      isOpen,
      expandRef,
      emailOptions,
      btnProps
    };
  }
};
export { script as default };